import { DataTable, PageWrapper, STATUSPAGE } from '@repo/ui';
import { GeneralFilters } from 'presentation/app/components/general-filters';
import { useEffect } from 'react';
import { Button, Card, CardBody } from 'reactstrap';

import noDataBg from '../../../assets/images/no-task.png';
import { makeColumnsArchivedGroupsList } from '../common/columns/columns-archived-groups-list';
import { useArchivedGroupsList } from '../hooks/useArchivedGroupsList';

export const ArchivedGroupsList = () => {
  // Hooks
  const {
    validation,
    paginationMetadata,
    listLoadingStatus,
    archivedGroupsListData,
    debouncedRequestGetAllArchivedGroups,
    getLegends,
    navigate,
    setListLoadingStatus,
    handlePageChange,
    handleSortRemote,
    handleSearchRemote,
    handleRowsPerPageChange,
    saveArchivedGroupsListFilters,
  } = useArchivedGroupsList();

  useEffect(() => {
    const valuesToSubmit = {
      entity: validation.values?.entity?.value,
      course: validation.values?.course?.value,
      semester: validation.values?.semester?.value,
      curricularUnit: validation.values?.unit?.value,
      page: paginationMetadata.selectedPage.toString(),
      length: paginationMetadata.rowsPerPage.toString(),
      order: paginationMetadata.sortDirection,
      orderColumn: paginationMetadata.orderColumn,
      query: paginationMetadata.searchString,
    };
    setListLoadingStatus(STATUSPAGE.LOADING);
    saveArchivedGroupsListFilters(validation.values);
    debouncedRequestGetAllArchivedGroups(valuesToSubmit);
  }, [
    validation.values?.entity,
    validation.values?.course,
    validation.values?.unit,
    validation.values?.semester,
    paginationMetadata,
  ]);

  // Constants
  const noDataConfig = {
    noDataTitle: 'Nenhum grupo arquivado encontrado',
    noDataDescription:
      'Use os filtros acima para pesquisar grupos arquivados por nome ou data.',
  };

  return (
    <PageWrapper title={`${getLegends('GRUPO', true)} Arquivados`}>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h4>{`${getLegends('GRUPO', true)} Arquivados`}</h4>
        <Button color="link" onClick={() => navigate('/grupos')}>
          Voltar p/ Grupos
        </Button>
      </div>
      <Card>
        <GeneralFilters
          validation={validation}
          additionalDependentInputs={[
            {
              id: 'group',
              isVisible: false,
              isDisabled: true,
              label: 'Grupos',
              options: [],
              placeholder: 'Selecione um grupo',
              onChange: function (e: any): void {
                throw new Error('Function not implemented.');
              },
            },
          ]}
          populateAdditionalDependentInputs={null}
        />
        <CardBody>
          <DataTable
            noDataTitle={noDataConfig.noDataTitle}
            noDataDescription={noDataConfig.noDataDescription}
            canSearch
            pagination
            sortServer
            searchServer
            actions={null}
            paginationServer
            defaultSortAsc={true}
            defaultSortFieldId={1}
            onSort={handleSortRemote}
            data={archivedGroupsListData?.data}
            columns={makeColumnsArchivedGroupsList()}
            onSearch={handleSearchRemote}
            onChangePage={handlePageChange}
            paginationTotalRows={archivedGroupsListData?.total}
            loading={listLoadingStatus === STATUSPAGE.LOADING}
            onChangeRowsPerPage={handleRowsPerPageChange}
          />
        </CardBody>
      </Card>
    </PageWrapper>
  );
};
